module.exports = __webpack_public_path__ + "static/story4-01-800x533-696c5146551d3fa3438f8fcb168e9ecb.jpg";